// Icon for the AI Response action: sparkles, the conventional "AI-generated"
// affordance, from the lucide icon set.

import { SparklesIcon } from 'lucide-react';

import { Icon } from '@/shared/types/icon';

export const AIResponseIcon = ({
  size = 16,
  color = 'var(--color-foreground-muted)',
  ...rest
}: Icon) => {
  return <SparklesIcon size={size} color={color} {...rest} />;
};
